<template>
  <div class="h-100 d-flex ai-center">
    <div class="x-header-link-container m-l-auto">
      <div
          v-for="(link, mIndex) in $options.LINKS.consumer"
          :key="mIndex"
          class="m-r-3 m-x-1:mo d-none:mo">
        <router-link
            :to="{name: link.name}"
            class="account-link m-l-auto:d"
            :class="{ 'active-account-link': link.name === currentSubRouteName }"
            :selenium="`header-${link.label}-link`">
          <div class="d-flex ai-center"><span v-if="link.icon" class="ai-center"><img
              class="ICON"
              src="./assets/Logout.svg"

          ></span>{{link.label}}<span
              v-if="link.name === 'consumer::inbox' && hasUnreadMessages"
              class="UNREAD-DOT"
              selenium="header-unread-messages-dot"/></div>

        </router-link>
      </div>
      <span
          class="account-link fd-row d-none:mo c-depot"
          :class="[isWhiteHeader ? 'header-link':'x-header-link']">
        <avatar
            :size="25"
            :name ="fullName"
            :image="profileImage"
            class="m-r-1 "
            selenium="consumer-avatar"/>
        <span class="m-r-1">{{ fullName }}</span>
      </span>
      <header-menu class="d-none:t">
        <template slot="button">
          <span
              class="d-flex flex-center d-none:mo"
              :class="[isWhiteHeader ? 'header-link':'x-header-link']">
            <avatar
                :size="30"
                :name ="fullName"
                :image="profileImage"
                class="m-r-1"
                selenium="consumer-avatar"/>
            <span class="m-r-1">{{ fullName }}</span>
          </span>
          <span class="x-header-link d-none:t">
            <vk-icon name="hamburger"/>
          </span>
        </template>
        <template slot="drawer">
          <router-link
              :to="{ name: 'consumer::dashboard' }"
              class="x-header-menu-link d-none:t"
              role="menuitem">
            My Requests
          </router-link>
          <router-link
              :to="{ name: 'account::info' }"
              class="x-header-menu-link"
              role="menuitem"
              selenium="header-account-settings-link">
            Account Info
          </router-link>
          <router-link
              :to="{ name: 'consumer::inbox' }"
              class="x-header-menu-link"
              role="menuitem"
              selenium="header-account-messages-link">
            Messages<span v-if="hasUnreadMessages" class="UNREAD-DOT"/>
          </router-link>
          <router-link
              :to="{ name: 'logout' }"
              class="x-header-menu-link"
              role="menuitem"
              selenium="header-logout-link">
            Logout
          </router-link>
        </template>
      </header-menu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HeaderHowItWorksButton from '@/layouts/components/HeaderHowItWorks/HeaderHowItWorksButton';
import HeaderMenu from '@/layouts/components/HeaderMenu';
import HeaderMenuChevron from '@/layouts/components/HeaderMenuChevron';
import LINKS from './link-constants';

export default {
  LINKS,
  name: 'app-header-consumer',
  components: {
    HeaderHowItWorksButton,
    HeaderMenu,
    HeaderMenuChevron,
  },
  computed: {
    ...mapGetters('user', [
      'fullName',
      'profileImage',
    ]),
    ...mapGetters('consumer/inbox', ['hasUnreadMessages']),
    isWhiteHeader () {
      return this.$route.name === 'homepage' || this.$route.name === 'consumer::dashboard';
    },
    currentSubRouteName () {
      return this.$route.name;
    },
  },
  mounted () {
    this.fetchInbox().catch((e) => {
      console.error(e); // eslint-disable-line no-console
    });
  },
  methods: {
    ...mapActions('consumer/inbox', ['fetchInbox']),
  },
};
</script>
<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.active-account-link {

  color: $color-depot !important;
  padding: 2 * $unit 0px  $unit  0px;
  border-bottom: 3px solid $color-depot !important;
}
.account-link {
    color: $color-depot;
    margin: 0px 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    display:flex;
    align-items: end;
    justify-items: flex-end;
    flex-direction: column;
    border-bottom: 3px solid transparent;
    padding: 2 * $unit 0px  $unit  0px;
    @include mobile-only {
      font-size: 12px;
      font-weight: 600;
    }
}
.router-link-exact-active{
    color: $color-depot;
}
.UNREAD-DOT {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 4px;
  border-radius: 50%;
  background-color: $color-red;
  align-self: flex-start;
}
.ICON {
  width: 20px;
  height: 20px;
  margin-right: $unit;
  padding-bottom:  $unit/ 2;
}

</style>
